export default {"src":"/_next/static/media/share_icon.2dd3cb08.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};